<template>
    <div>
        <div class="apply-part">
            <div class="apply-part-title">
                <div class="blue-sign"></div>
                <span>申请资料补交须知</span>
            </div>
            <div class="apply-part-content">
                <p>1、申请资格时未缴纳社保的，须在轮候或合同签订后3个月内补交社保缴纳证明。</p>
                <p>2、申请资格时未提交户籍证明的，须在轮候或合同签订后12个月内补交本市的居住证或本市户籍证明。</p>
                <p>3、请上传JPG格式的拍摄照片或PDF格式的彩色扫描件。</p>
            </div>
        </div>
        <el-divider v-if="status == 2 || status == 4"></el-divider>
        <div class="apply-part" v-if="status == 2 || status == 4">
            <div class="apply-part-title">
                <span>当前审核进度</span>
            </div>
            <div style="padding:25px 20px;">
                <span>审核进度：{{status == -1 ? "未提交" : statusName}}</span>
                <span v-if="nonPassReason != null && nonPassReason != ''" style="color:red">(退回原因：{{nonPassReason}})</span>
            </div>
        </div>

        <el-divider></el-divider>
        <div class="apply-part" v-if="socialSecuritySupply">
            <div class="apply-part-title">
                <span>社保缴费证明</span>
            </div>
            <div class="apply-part" style="margin-top: 20px; margin-left:25px;">
                <div class="apply-part-title" style="margin-bottom:15px;">
                    <span style="margin-left:0px;font-weight:normal;">社保缴纳证明扫描件(原件拍照或彩色扫描)</span>
                    <span
                    style="
                        font-size: 14px;
                        color: red;
                        margin-left: 33px;
                        font-weight: 400;
                    ">可在微信随申办小程序上可查询（在线证明→参保人员城镇职工基本养老保险缴费情况）</span>
                </div>
                <MultiUploader ref="uploader1" :disabled="status == 2"></MultiUploader>
            </div>
        </div>
        <div class="apply-part" v-if="residenceSupply" style="margin-top: 20px;">
            <div class="apply-part-title">
                <span>户籍证明</span>
            </div>

            <div class="apply-part" style="margin-top: 20px; margin-left:25px;" v-if="!isResidenceCard">
                <div class="apply-part-title" style="margin-bottom:15px;">
                    <span style="margin-left:0px;font-weight:normal;">户口性质</span>
                    <span>
                        <el-select v-model="tempIdentityType" style="width:200px" :disabled="status == 2" >
                            <el-option
                            v-for="item in identitytypelist"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                            </el-option>
                        </el-select>
                    </span>                   
                </div>
            </div>

            <div class="apply-part" style="margin-top: 20px; margin-left:25px;" v-if="tempIdentityType == '02'">
                <div class="apply-part-title" style="margin-bottom:15px;">
                    <span style="margin-left:0px;font-weight:normal;">上海市居住证扫描件(原件拍照或彩色扫描)</span>
                    <span
                    style="
                        font-size: 14px;
                        color: red;
                        margin-left: 33px;
                        font-weight: 400;
                    ">请上传上海市居住证原件正反面扫描件；确保居住证卡面有效期是否过期</span>
                </div>
                <MultiUploader ref="uploader2" :disabled="status == 2"></MultiUploader>
            </div>

            <div class="apply-part" style="margin-top: 20px; margin-left:25px;" v-if="tempIdentityType != '02'">
                <div class="apply-part-title" style="margin-bottom:15px;">
                    <span style="margin-left:0px;font-weight:normal;">本市户籍证明材料(原件拍照或彩色扫描)</span>
                    <span
                    style="
                        font-size: 14px;
                        color: red;
                        margin-left: 33px;
                        font-weight: 400;
                    ">请上传户口簿原件户主页(非沪籍人员除外)及本人信息页扫描件或本市户籍证明</span>
                </div>
                <MultiUploader ref="uploader3" :disabled="status == 2"></MultiUploader>
            </div>
        </div>

        <el-divider class="bottomdivider" v-if="status != 2"></el-divider>
        <div style="text-align: center" v-if="status != 2">
            <el-button type="primary" @click="onSubmit" :loading="loading">
                提交审核
            </el-button>
        </div>
    </div>
</template>

<script>
import UserApi from "@/api/user/index";
import MultiUploader from '../../components/upload/MultiUploader.vue';
export default {
    data(){
        return{
            disabled:false,
            loading:false,
            
            applyID:'',
            tempApplyID:'',
            status:'',
            statusName:'',
            nonPassReason:'',
            identityType:'',
            isSocialSecurity:'',
            isResidenceCard:'',
            socialSecuritySupply:false,
            residenceSupply:false,
            
            socialSecurityPhoto:'',
            residencePermitPhoto:'',
            residentCertificationPhoto:'',

            tempIdentityType:'',

            identitytypelist:[],
        }
    },
    components:{
        MultiUploader
    },
    methods:{
        getApplyInfo(id){
            UserApi.getApplyInfoSupply(id)
                .then(
                    (res) => {
                        this.applyID = id;
                        this.tempApplyID = res.data.id;
                        this.status = res.data.status;
                        this.statusName = res.data.statusName;
                        
                        this.nonPassReason = res.data.nonPassReason;

                        this.socialSecurityPhoto = res.data.socialSecurityPhoto;
                        this.residencePermitPhoto = res.data.residencePermitPhoto;
                        this.residentCertificationPhoto = res.data.residentCertificationPhoto;

                        this.identityType = res.data.identityType;
                        this.isSocialSecurity = res.data.isSocialSecurity;
                        this.isResidenceCard = res.data.isResidenceCard;
                        this.socialSecuritySupply = res.data.socialSecuritySupply;
                        this.residenceSupply = res.data.residenceSupply;

                        this.tempIdentityType = this.identityType;

                        if(this.status > 0){
                            if (this.tempIdentityType == "02") {
                                this.$nextTick(() => {
                                    this.$refs.uploader2.init(
                                        res.data.residencePermitPhoto,
                                        res.data.residencePermitPhotos
                                    );
                                });
                            }
                            else {
                                this.$nextTick(() => {
                                    this.$refs.uploader3.init(
                                        res.data.residentCertificationPhoto,
                                        res.data.residentCertificationPhotos
                                    );
                                });
                            }
                            if(this.socialSecuritySupply){
                                this.$nextTick(() => {
                                    this.$refs.uploader1.init(
                                        res.data.socialSecurityPhoto,
                                        res.data.socialSecurityPhotos
                                    );
                                });
                            }
                        }

                        this.identitytypelist = this.$Global.syscode.IdentityType;
                    },
                    (err) => {
                    this.$message({
                        message: err,
                        center: true,
                    });
                    }
                )
                .catch((error) => {
                this.$message({
                    message: error,
                    center: true,
                });
            });
        },

        onSubmit(){
            this.loading = true;

            // 从子组件中取附件
            var saveEntity = {rentBasicEntity:{id:this.applyID},rentQualificationsEntity:{},renterAttachments:{}};

            // 户口性质
            saveEntity.rentQualificationsEntity.identityType = this.tempIdentityType;

            // 材料附件
            saveEntity.renterAttachments.socialSecurityPhoto = "";
            saveEntity.renterAttachments.residencePermitPhoto = "";
            saveEntity.renterAttachments.residentCertificationPhoto = "";
            if(this.socialSecuritySupply){
                saveEntity.renterAttachments.socialSecurityPhoto = this.$refs.uploader1.getFiles()
            }

            if(this.residenceSupply){
                if(this.tempIdentityType == "02"){
                    saveEntity.renterAttachments.residencePermitPhoto = this.$refs.uploader2.getFiles()
                }
                else{
                    saveEntity.renterAttachments.residentCertificationPhoto = this.$refs.uploader3.getFiles()
                }
            }

            // 校验信息
            // 如果户口性质发生了变更，但是附件没有上传的
            if(this.tempIdentityType != this.identityType){
                if(this.tempIdentityType == "02" && saveEntity.renterAttachments.residencePermitPhoto.length <= 0){
                    this.$message.error({
                        message: "变更了户口性质，请上传居住证扫描件",
                        center: true,
                    });
                    this.loading = false;
                    return;
                }

                if(this.tempIdentityType != "02" && saveEntity.renterAttachments.residentCertificationPhoto.length <= 0){
                    this.$message.error({
                        message: "变更了户口性质，请上传本市户籍证明材料",
                        center: true,
                    });
                    this.loading = false;
                    return;
                }
            }

            if(saveEntity.renterAttachments.residencePermitPhoto.length <= 0
                && saveEntity.renterAttachments.socialSecurityPhoto.length <= 0
                && saveEntity.renterAttachments.residentCertificationPhoto.length <= 0){
                this.$message.error({
                    message: "您未更新上传任何资料，无需提交",
                    center: true,
                });
                this.loading = false;
                return;
            }

            this.$confirm('确认信息无误，提交申请？', '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    UserApi.submitApplyInfoSupply(this.tempApplyID,saveEntity).then(() => {
                            this.$confirm('提交成功，请关注资料补充审核结果！', '提示', {
                                showClose:false,
                                showCancelButton:false,
                                confirmButtonText: '我已知晓',
                                type: 'success',
                                closeOnPressEscape:false,
                                closeOnClickModal:false
                            }).then(() => {
                                location.reload();
                            })
                        },
                        (err) => {
                            this.$message.error({
                                message: err,
                                center: true,
                            });
                            this.loading = false;
                        }
                        )
                        .catch((error) => {
                            this.$message.error({
                                message: error,
                                center: true,
                            });
                            this.loading = false;
                        });
            }).catch(()=>{
                this.loading = false;
            })
        },
        downloadTable(){
            UserApi.printAddCoapplicantTable(this.tempApplyID).then(res=>{
                if(res.data){
                    window.open(res.data);
                }
            },err=>{
                this.$message.error(err);
            }).catch(error=>{
                this.$message.error(error);
            })
        }
    },
    activated(){
        if(this.$route.query.id){
            this.getApplyInfo(this.$route.query.id)
        }else{
            this.$router.push({path:'Error'})
        }
    }
}
</script>

<style scoped>
.apply-part{
    margin: 0 38px;
}
.apply-part-title{
    display: flex;
    align-items: center;
}
.blue-sign{
    width: 7px;
    height: 22px;
    background: #3B93EF;
    border: 1px solid #F1F1F1;
    border-radius: 3px;
}
.apply-part-title span{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    line-height: 18px;
    margin-left: 15px;
}
.apply-part-content{
    margin-top: 5px;
    padding: 5px;
    background-color:#FFFCF7;
    border:1px solid #FFEACC;
    font-size: 12pt;
    color:#0e698f
}
.apply-part-content p{
    line-height: 25px;
}

.add-family{
    background: #F9F9F9;
    width: 100%;
}
.avatar-uploader{
    background: #FFFFFF;
    width: 132px;
    height: 106px;
    border: 1px dashed #d9d9d9;
}
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 132px;
    height: 106px;
    line-height: 106px;
    text-align: center;
    border: none;
}
.avatar {
    width: 132px;
    height: 106px;
    display: block;
}
.compantip>>>.el-form-item__content{
    display: flex;
}
.compantip>>>.el-input.el-input--small{
    width: 400px;
}
.bottomdivider{
    margin-top:30px
}
.applystep >>>.is-process .is-text{
    background: #21A66D;
    border: none;
    color: #fff;
}
.applystep >>>.is-wait .is-text{
    background: #D0D0D0;
    border: none;
    color: #fff;
}
.applystep >>>.is-success .el-step__line{
    background: #21A66D;
}
.applystep >>>.is-success .is-text{
    color: #21A66D;
    border-color:#21A66D;
}
.applystep >>>.el-step__line{
    height: 8px;
    top :6px;
}
.applystep >>>.el-step__title{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
.relationunit{
    position: relative;
    color: #999999;
    border: 1px solid #999999;
    width: 100px;
    padding: 0 10px;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    margin-right: 20px;
}

.addhouseremark>>>.el-textarea__inner{
    width: 103.2%;
}
/* .appinput1 >>> .el-input__inner{
    width: 69.2%;
} */
.rightlabel >>> .el-input{
    width: auto;
}
.overlabel >>> .el-form-item__label{
    line-height: 14px;
}
.blueclose{
    position: absolute;
    right: -8px;
    top: -8px;
}
.applyType{
    margin-left: 130px;
    margin-bottom: 20px;
}
.el-divider{
    margin: 20px 38px 20px 38px;
}
</style>